import { Box, CircularProgress, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { apiVariable } from "../../../api/apiVariable";
import { assignedTrailersTableColumns } from "../../../data/FormColumns/Fleet/assignedTrailersTableColumns";

const fetchAssignedTrailers = async (
  token: string | null | undefined,
  truckId: string,
) => {
  const { data } = await axios.get(
    `${apiVariable}/getAssignedTrailerHistoryOnTruck/${truckId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return data;
};

interface AssignedTrailersProps {
  truckId: string;
  token: string | null | undefined;
}

const AssignedTrailers = ({ truckId, token }: AssignedTrailersProps) => {
  const {
    data: assignedTrailers,
    isLoading: isLoadingTrailers,
    isError: isErrorTrailers,
    error: trailerError,
  } = useQuery({
    queryKey: ["assignedTrailers", truckId],
    queryFn: () => fetchAssignedTrailers(token, truckId),
    enabled: !!truckId,
  });

  if (isLoadingTrailers) {
    return <CircularProgress />;
  }

  if (isErrorTrailers) {
    return (
      <Typography color="error">
        Error: {(trailerError as Error).message}
      </Typography>
    );
  }

  return (
    <Box sx={{ height: 400, width: { xs: "100%", sm: "80%" }, minWidth: 0 }}>
      <DataGrid
        rows={assignedTrailers || []}
        columns={assignedTrailersTableColumns}
      />
    </Box>
  );
};

export default AssignedTrailers;
